import React from 'react';

export default function Modal({ title, children, isOpen, onClose, maxWidth = 'max-w-lg' }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/80 backdrop-blur-xs flex items-center justify-center z-50 p-3 sm:p-4 overflow-y-auto">
      <div className={`bg-white dark:bg-gray-800 rounded-2xl p-4 sm:p-6 w-full ${maxWidth} max-h-[92vh] flex flex-col shadow-2xl border border-gray-100 dark:border-gray-700 my-auto`}>
        <div className="flex justify-between items-center mb-4 flex-shrink-0 border-b pb-3">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100 pr-2">{title}</h3>
          <button 
            onClick={onClose} 
            className="text-gray-400 dark:text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center text-2xl leading-none transition-colors"
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>
        <div className="overflow-y-auto pr-1 flex-1">{children}</div>
      </div>
    </div>
  );
}